export class FixView {
  constructor() {
    this.body = document.querySelector("body");
    this.scrollPos = 0;
  }

  fixed() {
    this.scrollPos = window.pageYOffset;
    this.body.style.top = `-${this.scrollPos}px`;
    this.body.style.position = "fixed";
    this.body.style.maxWidth = "100%";
  }

  static() {
    this.body.style.top = `${this.scrollPos}px`;
    this.body.style.position = "static";
    this.body.style.maxWidth = "none";
    if (this.scrollPos > 0) {
      //fixedしていない状態で処理を実行しない
      window.scrollTo(0, this.scrollPos);
    }
  }
}
